import courseReducer from '../course/course.reducer';

function save(sess, programObj) {
    const {Program, Attachment} = sess;
    if (Program.idExists(programObj.id)) {
        Program.withId(programObj.id).courses.toRefArray().forEach(courseObj => {
            courseReducer.remove(sess, courseObj.id);
        });
        Program.withId(programObj.id).attachments.toModelArray().forEach(attachmentModel => {
            attachmentModel.delete();
        });
    }
    
    let courses = [];
    if (programObj.courses) {
        courses = programObj.courses.map((courseObj, index) => {
            return courseReducer.save(sess, courseObj);
        });
    }

    let attachments = [];
    if (programObj.attachments) {
        attachments = programObj.attachments.map((attachmentObj) => {
            return Attachment.create(attachmentObj);
        });
    }

    return Program.create({
        ...programObj,
        courses,
        attachments
    });
}

function remove(sess, id) {
    const {Program} = sess;
    if (!Program.idExists(id)) {
        throw new Error(`can not find program with id '${id}'`);
    }
    Program.withId(id).courses.toRefArray().forEach((c) => {
        courseReducer.remove(sess, c.id);
    });
    return Program.withId(id).delete();
}

function updateMyProgramList(sess, {programsId, totalPage, page, nextPage, prePage, filters}) {
    const { List } = sess;
    let myProgramListModel = List.getByName('my-programs');
    if (!myProgramListModel) {
        List.create({
            name: 'my-programs',
            entityIds: programsId,
            filters: Object.entries(filters),
            page,
            totalPage,
            nextPage,
            prePage
        })
    } else {
        myProgramListModel.update({
            entityIds: programsId,
            filters: Object.entries(filters),
            page,
            totalPage,
            nextPage,
            prePage
        });
    }
    
}

export default {
    save,
    remove,
    updateMyProgramList,
};